import { render, staticRenderFns } from "./CustomCode.vue?vue&type=template&id=28b9091f&"
import script from "./CustomCode.vue?vue&type=script&lang=js&"
export * from "./CustomCode.vue?vue&type=script&lang=js&"
import style0 from "./CustomCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports